// Wait for the DOM to be fully loaded
$(document).ready(function () {
  // Function to animate the counter for a given element
  function runCounter(el) {
    var finalValue = parseInt(el.data("count"), 10); // Get the stored final value from data attribute
    var duration = 3000; // Animation duration in milliseconds (1 second)
    var startTime = null; // Initialize start time

    // Animation function using requestAnimationFrame
    function animateCounter(timestamp) {
      if (!startTime) startTime = timestamp; // Set start time on first call
      var progress = Math.min((timestamp - startTime) / duration, 1); // Calculate progress (0 to 1)
      var current = Math.floor(progress * finalValue); // Calculate current value to display
      el.text(current); // Update the element's text with the current value
      if (progress < 1) {
        requestAnimationFrame(animateCounter); // Continue animation if not finished
      }
    }

    requestAnimationFrame(animateCounter); // Start the animation
  }

  // Prepare all elements with class .count
  $(".count").each(function () {
    var $this = $(this); // Current element as jQuery object
    var finalValue = parseInt($this.text().replace(/,/g, ""), 10); // Parse the number, removing commas
    $this.data("count", finalValue); // Store the original number in data attribute
    $this.text("0"); // Set the displayed text to zero initially
  });

  // Create an IntersectionObserver to detect when elements appear on screen
  let observer = new IntersectionObserver(
    function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // If the element is visible
          runCounter($(entry.target)); // Start the counter animation
          observer.unobserve(entry.target); // Stop observing this element (run only once)
        }
      });
    },
    { threshold: 0.5 }
  ); // Trigger when 50% of the element is visible

  // Observe each .count element
  $(".count").each(function () {
    observer.observe(this); // Start observing the element
    // console.log(parseInt(el.data(".count")))
  });
});
